import { useBlocker } from "../../contexts";
import { BlockerContentInlineStyles, BlockerHeaderInlineStyles, BlockerFooterInlineStyles, BlockerFooter, BlockerHeader, BlockerBody } from ".";

var Blocker = function Blocker() {
  var blocker = useBlocker();
  return h("div", BlockerContentInlineStyles.inner(blocker), h("div", BlockerContentInlineStyles.content(blocker), h(BlockerHeader, null), h("div", BlockerHeaderInlineStyles.headerSeparator(blocker)), h(BlockerBody, null), h("div", BlockerFooterInlineStyles.footerSeparator(blocker)), h(BlockerFooter, null)));
};

export { Blocker };